function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "audioOffTitle"
}, "audio off");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M35.81 25.449c.938-.959 2.54-.28 2.54 1.075v26.952c0 1.355-1.602 2.034-2.54 1.075l-8.782-8.986v.014H22V34.435h5.028zm19.543 6.563L58 34.72 52.84 40 58 45.28l-2.647 2.708-5.16-5.28-5.16 5.28-2.647-2.709 5.16-5.28-5.16-5.279 2.647-2.708 5.16 5.28 5.16-5.28z",
  transform: "translate(-689 -273) translate(689 273)"
}))));

var SvgSettingsButtonUiSoundOffIcon = function SvgSettingsButtonUiSoundOffIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    "aria-labelledby": "audioOffTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "audioOffTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsButtonUiSoundOffIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-button-ui-sound-off-icon.c8b6187f.svg";
export { ForwardRef as ReactComponent };